import { ENGAJAMENTO_LABEL, PassoEngajamento } from "../types";

/**
 * Seletor da escada de engajamento musical (componente central do Compasso).
 * 10 passos (0–9). Tocar um passo seleciona — e todos abaixo "enchem" em verde
 * suave, comunicando progresso (não nota). Reaproveita as classes .escada do app.
 */
const PASSOS = Object.values(PassoEngajamento).filter(
  (v): v is PassoEngajamento => typeof v === "number",
);

export function EngajamentoSelector({
  valor,
  onChange,
}: {
  valor: PassoEngajamento | null;
  onChange: (p: PassoEngajamento) => void;
}) {
  return (
    <div className="escada" role="radiogroup" aria-label="passo na escada de engajamento">
      {PASSOS.map((p) => {
        const preenchido = valor !== null && p <= valor;
        const atual = valor === p;
        return (
          <button
            key={p}
            type="button"
            role="radio"
            aria-checked={atual}
            className={`escada-passo${preenchido ? " preenchido" : ""}${atual ? " atual" : ""}`}
            onClick={() => onChange(p)}
          >
            <span className="num" aria-hidden>
              {p}
            </span>
            <span>{ENGAJAMENTO_LABEL[p]}</span>
          </button>
        );
      })}
    </div>
  );
}
